import { z } from "zod";
import { isValidPhoneNumber } from "react-phone-number-input";
import { createCommonSchemas, TranslationFunction } from "../../lib/forms/utils";

/**
 * Contact form schema factory
 * Creates a Zod schema for contact form validation with i18n support
 */
export const createContactSchema = (t: TranslationFunction) => {
  const common = createCommonSchemas(t);
  
  return z.object({
    name: common.name,
    email: common.email,
    phone: common.phone,
    subject: z.string().min(1, t("Subject is required")),
    preferredContactMethod: z.enum(["email", "phone"]),
    // Honeypot field (should stay empty). We validate server-side.
    website: z.string().optional(),
    message: z.string()
      .min(1, t("Message is required"))
      .min(10, t("Message must be at least 10 characters"))
      .refine((val) => val.trim().length >= 10, t("Message must be at least 10 characters")),
  }).refine((data) => {
    // If phone is selected as preferred contact method, phone number is required
    if (data.preferredContactMethod === "phone") {
      return data.phone && data.phone.trim().length > 0 && isValidPhoneNumber(data.phone);
    }
    return true;
  }, {
    message: t("Phone number is required when phone is selected as preferred contact method"),
    path: ["phone"], // This will attach the error to the phone field
  });
};

export type ContactFormData = z.infer<ReturnType<typeof createContactSchema>>;

